import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const { Form } = Common;

const CompanyDeleteModal = ({ t, company, isOpened, handleClose, handleAccept }) => {
  return (
    <Common.Modal show={isOpened} handleClose={handleClose} keyboard={false}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLongTitle">
            {t('companies.delete_title')}
          </h5>
          <button type="button" className="close" onClick={handleClose}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div
          className="modal-body"
          dangerouslySetInnerHTML={{
            __html: t('companies.delete_confirm', company),
          }}
        />
        <div className="modal-footer">
          <Form.Button
            type="button"
            className="btn btn-secondary"
            text={t('actions.cancel')}
            onClick={handleClose}
          />

          <Form.Button
            type="button"
            className="btn btn-warning"
            text={t('actions.confirm')}
            onClick={handleAccept}
          />
        </div>
      </div>
    </Common.Modal>
  );
};

export default translate()(CompanyDeleteModal);



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/components/CompanyDeleteModal.js